import React from "react";

const Wrapper = ({ children }) => {
  return <main>{children}</main>;
};

export default Wrapper;
